import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { X } from "lucide-react";
import { useEffect } from "react";
import bookingBg from "@/assets/booking-popup-bg.jpg";

interface TubingBookingPopupModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function TubingBookingPopupModal({ open, onOpenChange }: TubingBookingPopupModalProps) {
  useEffect(() => {
    if (open) {
      // Load the Checkfront script
      const existingScript = document.querySelector('script[src*="checkfront.com/lib/interface"]');
      if (!existingScript) {
        const script = document.createElement("script");
        script.src = "//sonsguadalupe.checkfront.com/lib/interface--0.js";
        script.type = "text/javascript";
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
          initWidget();
        };
      } else {
        // Script already loaded, just init the widget
        setTimeout(initWidget, 100);
      }
    }
  }, [open]);

  const initWidget = () => {
    if (window.DROPLET) {
      const targetEl = document.getElementById("CHECKFRONT_WIDGET_TUBING");
      if (targetEl) {
        targetEl.innerHTML = '<p id="CHECKFRONT_LOADER" style="background: url(\'//sonsguadalupe.checkfront.com/images/loader.gif\') left center no-repeat; padding: 5px 5px 5px 20px">Searching Availability...</p>';
      }
      new window.DROPLET.Widget({
        host: "sonsguadalupe.checkfront.com",
        target: "CHECKFRONT_WIDGET_TUBING",
        item_id: "289,19,190",
        category_id: "2",
        options: "tabs",
        style: "color: fff",
        provider: "droplet",
      }).render();
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent 
        className="max-w-4xl w-[95vw] max-h-[90vh] overflow-y-auto p-0 border-0 bg-transparent"
        hideDefaultClose
      >
        <DialogTitle className="sr-only">Book Your Tubing Experience</DialogTitle>
        
        {/* Sticky close button - always visible at top right */}
        <div className="sticky top-0 z-50 flex justify-end pt-4 pr-4 pointer-events-none">
          <button
            onClick={() => onOpenChange(false)}
            className="pointer-events-auto w-10 h-10 md:w-10 md:h-10 rounded-full bg-charcoal/90 hover:bg-charcoal flex items-center justify-center transition-colors shadow-lg border-2 border-white/30"
            aria-label="Close"
          >
            <X className="w-5 h-5 text-white" />
          </button>
        </div>
        
        {/* Background with smokey overlay */}
        <div 
          className="relative rounded-lg overflow-hidden"
          style={{ 
            backgroundImage: `url(${bookingBg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          {/* Smokey overlay */}
          <div className="absolute inset-0 bg-charcoal/70 backdrop-blur-sm" />
          
          {/* Content */}
          <div className="relative z-10 p-6 md:p-8">
            <h2 className="font-lora text-2xl md:text-3xl font-bold text-white text-center mb-6">
              Book Your Tubing Experience
            </h2>
            
            {/* Checkfront Widget Container */}
            <div className="bg-transparent p-4 md:p-6 min-h-[400px]">
              <div id="CHECKFRONT_WIDGET_TUBING">
                <p 
                  id="CHECKFRONT_LOADER" 
                  style={{ 
                    background: "url('//sonsguadalupe.checkfront.com/images/loader.gif') left center no-repeat", 
                    padding: "5px 5px 5px 20px" 
                  }}
                >
                  Searching Availability...
                </p>
              </div>
              <noscript>
                <a 
                  href="https://sonsguadalupe.checkfront.com/reserve/" 
                  style={{ fontSize: "16px" }}
                >
                  Continue to Secure Booking System »
                </a>
              </noscript>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
